import type { AnalyticsPageNotifierChannels } from '@bcf-vanilla-ts-v1-logic-worker-others/bloc/analytics-page-notifier/analytics-page-notifier-channels';
import { transferRxNext } from '@bcf-vanilla-ts-v1-shared/misc/rx-helpers/transfer-rx-next';
import { checkCasinoPageAnalytics } from '@bcf-vanilla-ui-ts-v1/shared/analytics/check-page-analytics';
import {
  provideBcfActivatedRoute,
  type BcfActivatedRoute
} from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-activated-route';
import {
  provideBcfActivatedUrl,
  type BcfActivatedUrl
} from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-activated-url';
import { UnsubscribableWithWorkerBlocForService } from '@bcf2-v1-platforms/platform-worker/browser/unsubscribable-with-worker-bloc-for-service';
import type { ReactiveControllerHost } from 'lit';
import { provideGtmService, type GtmService } from './gtm.service';

export class GtmPageNotifierService extends UnsubscribableWithWorkerBlocForService<AnalyticsPageNotifierChannels> {
  constructor(
    private _activatedUrl: BcfActivatedUrl,
    private _activatedRoute: BcfActivatedRoute,
    private _gtmService: GtmService,
    host: ReactiveControllerHost
  ) {
    super(host);
    this._initWorkerBloc('analytics-page-notifier');
  }

  public override init(): void {
    this._sub = checkCasinoPageAnalytics(this._activatedUrl.url$, this._activatedRoute.params, this._gtmService);

    this._sub = this._subTo('userInfoDetails').subscribe(transferRxNext(this._gtmService.userInfoDetails$));
    this._sub = this._subTo('registrationDateElapsedDaysFromToday').subscribe(
      transferRxNext(this._gtmService.userRegistrationDateFromTodayElapsedDays$)
    );
  }
}

export function provideGtmPageNotifierService(host: ReactiveControllerHost): GtmPageNotifierService {
  return new GtmPageNotifierService(provideBcfActivatedUrl(), provideBcfActivatedRoute(), provideGtmService(), host);
}
